export interface Veiculo {
  id: number;
  placa: string;
  marca: string;
  modelo: string;
  ano?: number | null;
  cor?: string | null;
  kilometragem_atual: number;
  media_consumo_km_litro?: number | null;
  escritorio_id: number;
  status: 'ativo' | 'inativo' | 'manutencao';
  observacoes?: string | null;
  foto_url?: string | null;
  motorista_atual?: { id: number; nome: string; cargo?: string; celular?: string } | null;
  escritorio?: { id: number; nome_fantasia: string; identificacao?: string };
  multas?: VeiculoMulta[];
  createdAt?: string;
  updatedAt?: string;
}

export type TipoVeiculoEvento = 'entrega' | 'devolucao' | 'outro';
export type NivelCombustivel = 'vazio' | '1/4' | '1/2' | '3/4' | 'cheio';

export const TIPOS_VEICULO_EVENTO: { value: TipoVeiculoEvento; label: string }[] = [
  { value: 'entrega', label: 'Entrega' },
  { value: 'devolucao', label: 'Devolução' },
  { value: 'outro', label: 'Outro' },
];

export const NIVEIS_COMBUSTIVEL: { value: NivelCombustivel; label: string }[] = [
  { value: 'vazio', label: 'Vazio' },
  { value: '1/4', label: '1/4' },
  { value: '1/2', label: '1/2' },
  { value: '3/4', label: '3/4' },
  { value: 'cheio', label: 'Cheio' },
];

export interface VeiculoEventoAnexo {
  id: number;
  veiculo_evento_id: number;
  url: string;
  nome_arquivo?: string | null;
  tipo: string;
  tamanho?: number | null;
}

export interface VeiculoEvento {
  id: number;
  veiculo_id: number;
  tipo: TipoVeiculoEvento;
  funcionario_id?: number | null;
  kilometragem?: number | null;
  nivel_combustivel?: NivelCombustivel | null;
  data_evento: string;
  observacoes?: string | null;
  dados_extras?: Record<string, unknown> | null;
  usuario_lancou_id: number;
  escritorio_id: number;
  veiculo?: { id: number; placa: string; modelo: string; marca: string };
  motorista?: { id: number; nome: string; cargo?: string; celular?: string };
  usuario_lancou?: { id: number; nome: string; usuario?: string };
  anexos?: VeiculoEventoAnexo[];
  createdAt?: string;
  updatedAt?: string;
}

export type CategoriaHistoricoVeiculo = 'evento' | 'abastecimento' | 'manutencao' | 'troca_oleo' | 'multa';

export interface VeiculoHistoricoItem {
  id: string;
  categoria: CategoriaHistoricoVeiculo;
  data: string;
  titulo: string;
  detalhes: string;
  km?: number | null;
  motorista?: string;
  motorista_id?: number | null;
  valor?: number | null;
  status?: string;
  anexos?: VeiculoEventoAnexo[];
  raw: VeiculoEvento | RequisicaoAbastecimento | ManutencaoVeiculo | TrocaOleo | VeiculoMulta;
}

export interface VeiculoMulta {
  id: number;
  veiculo_id: number;
  funcionario_id?: number | null;
  data_multa: string;
  infracao: string;
  valor: number;
  pontos?: number | null;
  data_vencimento?: string | null;
  status: 'pendente' | 'paga' | 'contestada';
  observacoes?: string | null;
  motorista?: { id: number; nome: string };
}

export type TipoCombustivel = 'gasolina' | 'etanol' | 'diesel' | 'gnv' | 'outro';

export const TIPOS_COMBUSTIVEL: { value: TipoCombustivel; label: string }[] = [
  { value: 'gasolina', label: 'Gasolina' },
  { value: 'etanol', label: 'Etanol' },
  { value: 'diesel', label: 'Diesel' },
  { value: 'gnv', label: 'GNV' },
  { value: 'outro', label: 'Outro' },
];

export interface RequisicaoAbastecimento {
  id: number;
  veiculo_id: number;
  kilometragem_atual: number;
  valor: number;
  tipo_combustivel: TipoCombustivel;
  valor_litro: number;
  quantidade_litros: number;
  funcionario_solicitante_id: number;
  usuario_lancou_id: number;
  usuario_aprovou_id?: number | null;
  data_requisicao: string;
  mes_referencia?: string | null;
  status: 'pendente' | 'aprovada' | 'rejeitada' | 'apurada' | 'paga';
  observacoes?: string | null;
  despesa_id?: number | null;
  escritorio_id: number;
  veiculo?: { id: number; placa: string; modelo: string; marca: string };
  funcionario_solicitante?: { id: number; nome: string };
  usuario_lancou?: { id: number; nome: string; usuario: string };
  usuario_aprovou?: { id: number; nome: string };
  despesa?: { id: number; descricao: string; valor: number; status: string };
}

export interface ManutencaoVeiculo {
  id: number;
  veiculo_id: number;
  tipo: 'preventiva' | 'corretiva' | 'requisicao';
  problema?: string | null;
  descricao_servico?: string | null;
  mecanica?: string | null;
  fornecedor_id?: number | null;
  valor?: number | null;
  kilometragem?: number | null;
  data_manutencao: string;
  status: 'pendente' | 'agendada' | 'em_andamento' | 'concluida' | 'cancelada';
  funcionario_solicitante_id?: number | null;
  usuario_lancou_id: number;
  despesa_id?: number | null;
  observacoes?: string | null;
  escritorio_id: number;
  veiculo?: { id: number; placa: string; modelo: string; marca: string };
  funcionario_solicitante?: { id: number; nome: string };
  fornecedor?: { id: number; nome: string };
}

export interface TrocaOleo {
  id: number;
  veiculo_id: number;
  kilometragem: number;
  data_troca: string;
  tipo_oleo?: string | null;
  proxima_troca_km?: number | null;
  proxima_troca_data?: string | null;
  valor?: number | null;
  mecanica?: string | null;
  fornecedor_id?: number | null;
  observacoes?: string | null;
  usuario_lancou_id: number;
  escritorio_id: number;
  veiculo?: { id: number; placa: string; modelo: string; marca: string };
}

export interface MeuVeiculoData {
  veiculo: Veiculo;
  requisicoes_abastecimento: RequisicaoAbastecimento[];
  manutencoes: ManutencaoVeiculo[];
}

export interface ApuracaoResumo {
  mes_referencia: string;
  quantidade: number;
  valor_total: number;
  requisicoes: RequisicaoAbastecimento[];
}

export interface AlertaTrocaOleo {
  veiculo_id: number;
  placa: string;
  marca: string;
  modelo: string;
  km_atual: number;
  proxima_troca_km: number;
  km_restantes: number;
  data_ultima_troca: string;
  data_ultimo_abastecimento: string | null;
  urgencia: 'proximo' | 'vencido';
}
